export const environment = {
    production: true,
    apiUrl: 'https://toolkit-api-stg.dnb.com/services/ToolkitXMLGateway',
    mauiLogo:'http://www-stg.dnb.com/',
    sessionUrl:'https://toolkit-api-stg.dnb.com/rest/Toolkit/Authentication',
    signupUrl:'https://toolkit-api-stg.dnb.com/services/ToolkitAEWSAuthentication',
    mauiDnbdotCom:'http://www-stg.dnb.com/',
    mauiContactUs:'https://www-stg.dnb.com/contact-us.html',
    rumToken:'50gUcnflivsLQ7oOJ4Lk6w',
    realm:'us2',
    env: 'staging'
};
